<template>
	<div class="main">
		<Steps :index="1" :product-name="info.productName" />
		<ApplicantInfo v-if="info" :info="info" />
		<RecognizeInfo :info="info" class="mt20" />
		<div>
			<Upload :info="info" ref="insurance" :multiple="true" />
			<div class="mt15 agree flex">
				<Checkbox v-model="agree">我已经阅读并同意</Checkbox>
				<div>
					<a href="/static/pdf/haierProduct/tongxian/人保健康福佑相伴人身意外团体意外伤害保险（B款）.pdf" target="_blank" referrerpolicy="no-referrer">《人保健康福佑相伴人身意外团体意外伤害保险（B款）》条款</a><br />
					<a href="/static/pdf/haierProduct/tongxian/中国人民健康保险股份有限公司守护专家意外医疗（推广版）团体医疗保险.pdf" target="_blank" referrerpolicy="no-referrer">《中国人民健康保险股份有限公司守护专家意外医疗（推广版）团体医疗保险》条款</a><br />
					<a href="/static/pdf/haierProduct/tongxian/中国人民健康保险股份有限公司守护专家住院定额团体医疗保险.pdf" target="_blank" referrerpolicy="no-referrer">《中国人民健康保险股份有限公司守护专家住院定额团体医疗保险》条款</a>
				</div>
			</div>
			<div class="mt20 center">
				<p>保费合计：<span class="price">{{info.premium}}元</span></p>
				<p class="mt10">
					<Button type="primary" :disabled="!agree" @click="toPay" :loading="loading">确认投保</Button>
				</p>
			</div>
		</div>
	</div>
</template>
<script>
import RecognizeInfo from './recognizeInfo'
import ApplicantInfo from './common/applicantInfo'
import Upload from './common/upload'
import Steps from './common/steps'

import track from "@/mixin/track";
export default {
	components:{ RecognizeInfo,ApplicantInfo,Steps,Upload},
	mixins:[track],
	data () {
		return {
			info:{
				id:this.$route.params.id,
			},
			loading:false,
			agree:false,
			id:this.$route.params.id,
			timer:null
		}
	},
	created(){
		if(this.id){
			this.getInfo();
		}
	},
	mounted () {
		// 回溯 开始录制
		this.$nextTick(this.startRecord);
	},
	beforeDestroy() {
		//在 beforeDestroy生命周期函数中销毁定时器
		clearInterval(this.timer);
		this.timer = null;
	},
	methods:{
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/casual/insurance/user.json.dst',{
				billNo: this.id
			}).then(res=>{
				this.info = res;
			});
		},
		// 支付
		async toPay () {
			/*获取投保单*/
			let insuranceForm = await this.$refs.insurance.val();
			// if(!insuranceForm){
			//     this.toast('请上传投保单','error');
			// 	return
			// }
			let form = {}
			if(insuranceForm&&insuranceForm.fileList.length>0){
			    form.attachment = insuranceForm.fileList
			}
			this.loading=true;
			this.$axios.post('/casual/insurance/attachement.json.all',{
				billNo: this.id,
				...form
			}).then(async res=>{
				if(String(res.code)==='10000000'){
					// 回溯 停止录制
					await this.stopRecord({
						policy_id:this.id
					});
					this.$router.push(`/lineWork/success/${this.id}`)
				} else {
					this.loading = false;
					this.alert(res.msg);
				}
			}).catch(err=>{
				this.loading=false;
			})
		}
	}
}
</script>
<style scoped lang="less">
	.font-weight{
		font-weight: bold;
	}
	.main{
		background: #fff;
		margin-top: 24px;
		padding :30px 40px;
	}
	.mt20{
	    line-height: 1.8;
	}
	span.price{
	    color:#FF0000;
	    font-weight: bold;
	}
	.font14{
		font-size: 16px;
	}
	.font20 {
		font-size: 24px;
	}
	.flex {
		display: flex;
		align-items: flex-start;
		justify-content: left;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/confirm.vue